import React from 'react';
import styled from 'styled-components';
import networkHeroImage from '../../../assets/landing.jpg';

const HeroContainer = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    text-align: center;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const TextContent = styled.div`
  flex: 1;
  color: white;
`;

const Title = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 1.5rem;
  background: linear-gradient(90deg, #4ECDC4 0%, #FFD93D 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: #b3e6ff;
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 600px;
`;

const CTAButton = styled.button`
  background: linear-gradient(90deg, #4ECDC4 0%, #2AB3A6 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.125rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;
  box-shadow: 0 4px 15px rgba(78, 205, 196, 0.3);

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 0.875rem 1.75rem;
    font-size: 1rem;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(78, 205, 196, 0.2) 0%, transparent 70%);
    z-index: 1;
  }
`;

const HeroImage = styled.img`
  max-width: 100%;
  height: auto;
  filter: drop-shadow(0 0 20px rgba(78, 205, 196, 0.3));
  animation: float 6s ease-in-out infinite;
  z-index: 2;

  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;

export const HeroSection: React.FC = () => {
  return (
    <HeroContainer>
      <Content>
        <TextContent>
          <Title>Transform Your Events with Interactive Networking</Title>
          <Subtitle>
            Elevate your corporate events, conferences, and team buildings with our 
            innovative wheel-based networking solution. Create meaningful connections 
            through engaging, randomized interactions.
          </Subtitle>
          <CTAButton onClick={() => document.getElementById('pricing-section')?.scrollIntoView({ behavior: 'smooth' })}>Get Started</CTAButton>
        </TextContent>
        <ImageContainer>
          <HeroImage src={networkHeroImage} alt="SpinToConnect Network Visualization" />
        </ImageContainer>
      </Content>
    </HeroContainer>
  );
}; 